document.addEventListener('DOMContentLoaded', function () {
    const video = document.getElementById('section-video');
    const toggleBtn = document.getElementById('video-toggle');
    if (!video || !toggleBtn) {
        console.warn('Video section elements not found');
        return;
    }
    const playIcon = toggleBtn.querySelector('.icon-play');
    const pauseIcon = toggleBtn.querySelector('.icon-pause');
    if (!playIcon || !pauseIcon) {
        console.warn('Video toggle icons not found');
        return;
    }

    toggleBtn.addEventListener('click', function () {
        if (video.paused) {
            video.play();
            playIcon.style.display = 'none';
            pauseIcon.style.display = 'inline';
        } else {
            video.pause();
            playIcon.style.display = 'inline';
            pauseIcon.style.display = 'none';
        }
    });
}); 